/**
 * PC_TF_01 
 * Importing the component, API and packages
 */
import React, { useEffect, useState } from "react";
import { getTemplateCategoryDetails, updateTemplate, postTemplate } from "../../service/PerformanceAPI";
import { Link, useParams, useNavigate, useLocation } from "react-router-dom";
import { Upload, uploadBackend } from "../../utils/Upload";
import { useRef } from "react";
import { encryptStorage } from "../../constant";

import './Template.css'
import BreadCrumbs from "../../components/BreadCrumbs/BreadCrumbs";
import Loader from "../../StaticComponent/Loader";
import { OnlyNumberSpecialChar } from "../../utils/RegHandling";
import _ from 'lodash';


export default function GoalTemplateForm() {
    const { templateId } = useParams();
    const navigate = useNavigate();
    const { state } = useLocation();
    const attachment = useRef()


    /**
     * PC_TF_02
     * State variables are created
     */
    let dataObj = { templateId: "", templateTitle: "", category_id: "", templateDescription: "", templateAttachment: "", };

    const [category, setCategory] = useState([]);
    const [templateData, setTemplateData] = useState(dataObj);
    const [pageMode, setPageMode] = useState(false);
    const [templateTitleValidation, settemplateTitleValidation] = useState("")
    const [templateDescriptionValidation, settemplateDescriptionValidation] = useState("")
    const [CategoryValidation, setCategoryValidation] = useState("")
    const [uploadValidation, setUploadValidation] = useState("")
    const [breadCrumbsData, setbreadCrumbsData] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const [selectedFileName, setSelectedFileName] = useState('');


    const [templateDataOld, setTemplateDataOld] = useState(dataObj);
    const [oldSelectedFileName, setOldSelectedFileName] = useState('')
    const [disabledCheck, setDisabledCheck] = useState(false);


    /**
    * PC_TF_03,PC_TF_04,PC_TF_05
    * useEffect is invoked then loadTemplateData function is called
    * templateid is checked, whether template has to  edit the getTemplateCategoryDetails is called with template id
    */
    useEffect(() => {
        if (encryptStorage.getItem('groupid') == 1 || encryptStorage.getItem('groupid') == 2 ) {
            setbreadCrumbsData([
                { title: 'Dashboard', path: '/overview', isActive: true },
                { title: 'Team Members', path: '', isActive: true },
                { title: 'Manage Goal Template', path: '/goaltemplate', isActive: true, state: { state: { way: 'nav' } } },
                { title: 'Add Goal Template', path: '', isActive: false },
            ])
            getTemplateCategoryDetails().then(res => {
                setCategory(res.data.ResponseData.category);

            });
            if (templateId) {
                setbreadCrumbsData([
                    { title: 'Dashboard', path: '/overview', isActive: true },
                    { title: 'Team Members', path: '', isActive: true },
                    { title: 'Manage Goal Template', path: '/goaltemplate', isActive: true, state: { state: { way: 'nav' } } },
                    { title: 'Edit Goal Template', path: '', isActive: false },
                ])
                setIsLoading(false)
                getTemplateCategoryDetails({ "category_id": "", "id": templateId }).then((res) => {

                    if (encryptStorage.getItem('employeeId') === res.data.ResponseData.template[0].created_by) {
                        let individualData = {
                            templateId: res.data.ResponseData.template[0].id,
                            category_id: Number(res.data.ResponseData.template[0].category_id),
                            templateTitle: res.data.ResponseData.template[0].name,
                            templateDescription: res.data.ResponseData.template[0].description,
                            templateAttachment: res.data.ResponseData.template[0].attachment_url,
                        };
                        let fileName = res.data.ResponseData.template[0].attachment_url.split('.com/')[1]
                        setSelectedFileName(fileName)
                        setOldSelectedFileName(fileName)
                        setTemplateData(individualData);
                        setTemplateDataOld(individualData)
                        setPageMode(true);
                        setIsLoading(true)
                    } else {
                        navigate('/', { state: { hideNav: false } });
                    }


                })
            }
        } else {
            navigate('/', { state: { hideNav: false } });
        }

    }, []);


    useEffect(() => {
        if (pageMode) {



            let isSame = _.isEqual(templateData, templateDataOld);
            // ((oldSelectedFileName != selectedFileName))
            //     ? setDisabledCheck(false) : 
            isSame ? setDisabledCheck(true) : setDisabledCheck(false)
        }
    }, [templateData, templateDataOld, disabledCheck])

    /**
     * PC_TF_12 
     * @param {*} e OnchangeName function is invoked when user change the data  
     */
    const OnChangeName = (e) => {
        setTemplateData({ ...templateData, [e.target.name]: e.target.name == "category_id" ? Number(e.target.value) : e.target.value });
    };

    /**
     * PC_TF_15
     * @returns the image link after uploading the image in s3 bucket
     */
    const fileUpload = async () => {
        let dirName = `Goal-Template`;
        let file = attachment.current.files[0];
        let newFileName = attachment.current.files[0].name;
        let fileData = await uploadBackend(file, newFileName,dirName);
        return fileData

    };
    /**
        * PC_TF_14 validation for form fields done and validation message are set in state variable
        */
    const Validation = () => {

        let result = true
        if (templateData.templateTitle.trim() === "") {
            settemplateTitleValidation("Template Title is required");
            result = false
        }
        else {
            let checkregex = OnlyNumberSpecialChar(templateData.templateTitle)
            if (checkregex) {
                result = false
                settemplateTitleValidation("Template Title is not valid")
            } else {
                settemplateTitleValidation("")
            }
        }

        if (templateData.templateDescription.trim() === "") {
            settemplateDescriptionValidation("Description is required");
            result = false
        }
        else {
            let checkregex = OnlyNumberSpecialChar(templateData.templateDescription)
            if (checkregex) {
                result = false
                settemplateDescriptionValidation("Description is not valid")
            } else {
                settemplateDescriptionValidation("")
            }
        }
        if (templateData.category_id == "") {
            setCategoryValidation("Category is required");
            result = false
        }
        else {
            setCategoryValidation("");
        }

        if (attachment.current.files.length > 0) {
            function isImage(icon) {
                const ext = ['.jpg', '.jpeg', '.png', '.svg'];

                return ext.some(el => icon.endsWith(el));
            }
            if (!isImage(attachment.current.value)) {
                result = false
                setUploadValidation("The uploaded file should be in  JPG, PNG, JPEG, SVG format");
            }
            else setUploadValidation("");

        }


        return result
    };

    /**
   * PC_TF_13,PC_TF_15,PC_TF_20,PC_TF_21
   * submitClick function is invoked when user click save button 
   * pageMode is checked and post/update API is called then based on the response user is redirect to template grid page
   */
    const submitClick = async (e) => {

        let valid = Validation();
        if (valid) {
            if (pageMode) {
                let data;
                setIsLoading(false)
                if (attachment.current.files.length > 0) {
                    data = await fileUpload()
                }
                let update = { ...templateData, templateAttachment: data ? data : templateData.templateAttachment }

                let updateResponse = await updateTemplate(update);

                if (updateResponse.data.ResponseData.Message == "Successfully update") {
                    setIsLoading(true)
                    sessionStorage.setItem('templateToast', 'updated')
                    navigate('/goaltemplate', state.type !== undefined ? { state: { ...state, popUp: "updated", type: state?.type } } : { state: { ...state, popUp: "updated" } });
                }
            } else {
                let data
                setIsLoading(false)
                if (attachment.current.files.length > 0) {
                    data = await fileUpload()
                }
                let postData = {
                    templateTitle: templateData.templateTitle,
                    templateDescription: templateData.templateDescription,
                    category_id: templateData.category_id,
                    templateAttachment: data ? data : "",
                    created_by: encryptStorage.getItem('employeeId')
                };
                let postResponse = await postTemplate(postData);
                if (postResponse.data.ResponseData.Message == "Successfully inserted") {
                    setIsLoading(true)
                    sessionStorage.setItem('templateToast', 'inserted')
                    navigate("/goaltemplate", state.type !== undefined ? { state: { ...state, popUp: "inserted", type: state?.type } } : { state: { ...state, popUp: "inserted" } });
                }
            }
        }

    };

    return (
        <>
            {isLoading ?
                <div className="body-bg">
                    <div className="coverpic container-fluid">

                        <div className="row justify-content-center mt-5">
                            <div className="col-md-8 p-4 mt-5 bg-white rounded-3">
                                <div>
                                    <BreadCrumbs data={breadCrumbsData} />
                                </div>
                                <p className="font-15 tt-bold goal-form-label">
                                    {templateId ? 'Edit Goal Template' : 'Add Goal Template'}
                                </p>
                                {/*Form structure starts Here*/}
                                <div className="row mb-3 ">

                                    <div className="col-md-6 mb-3">
                                        <label
                                            htmlFor="goal-title"
                                            className="form-label hive-form-label"
                                        >
                                            Goal Template Title <span className="required">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control hive-form-control"
                                            id="goal-title"
                                            placeholder="Enter Template Title"
                                            name="templateTitle"
                                            value={templateData.templateTitle}
                                            maxLength={255}
                                            onChange={(e) => { settemplateTitleValidation(''); OnChangeName(e) }}
                                        />
                                        <label className="text-danger">
                                            {templateTitleValidation}
                                        </label>
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <label
                                            htmlFor="goal-category"
                                            className="form-label  hive-form-label"
                                        >
                                            Category <span className="hive-form-mandatory">*</span>
                                        </label>
                                        <select
                                            className="form-select hive-form-select"
                                            aria-label="Default select example"
                                            id="goal-category"
                                            name="category_id"
                                            value={templateData.category_id}
                                            onChange={(e) => { setCategoryValidation(''); OnChangeName(e) }}
                                        >
                                            <option value='' >Select</option>
                                            {category.map((singleCategory) => {
                                                return (
                                                    <option value={Number(singleCategory.id)}>
                                                        {singleCategory.category_name}
                                                    </option>
                                                );
                                            })}
                                        </select>
                                        <label className="text-danger">
                                            {CategoryValidation}
                                        </label>
                                    </div>
                                    <div className="col-md-12 mb-3">
                                        <label
                                            htmlFor="goal-objective"
                                            className="form-label  hive-form-label"
                                        >
                                            Add a Objective{" "}
                                            <span className="hive-form-mandatory">*</span>
                                        </label>
                                        <textarea
                                            className="form-control custom-comment-box hive-form-control"
                                            id="goal-objective"
                                            placeholder="Enter Template Objective"
                                            rows={3}
                                            name="templateDescription"
                                            value={templateData.templateDescription}
                                            maxLength={5000}
                                            onChange={(e) => { settemplateDescriptionValidation(''); OnChangeName(e) }}
                                        />
                                        <label className="text-danger">
                                            {templateDescriptionValidation}
                                        </label>
                                    </div>
                                    <div className="col-md-3 mb-3 mt-3">
                                        <label className="form-label  hive-form-label w-100">Attachment<span className="mx-2"><img src="/Images/help-black.svg" alt="help-icon" data-bs-toggle="tooltip" data-bs-placement="bottom" title data-bs-original-title="Working Days " aria-label="Working Days " /></span></label>
                                        <div className="profile-upload-btn">
                                            <label htmlFor="voterid-upload" className="goalform-custom-file-upload">
                                                <img className="me-2" src="/Images/profile-upload-icon.svg" alt="Upload Icon" />
                                                Upload
                                            </label>

                                            <input id="voterid-upload" className="goal-file-upload"
                                                onChange={(e) => {

                                                    setUploadValidation('');
                                                    if (e.target.files.length > 0) {
                                                        setSelectedFileName(e.target.files[0].name);
                                                        setTemplateData({ ...templateData, ["templateAttachment"]: e.target.files[0].name });
                                                    }
                                                    else {
                                                        setSelectedFileName('');
                                                        setTemplateData({ ...templateData, ["templateAttachment"]: '' });

                                                    }
                                                    // if ((oldSelectedFileName == e.target.files[0].name)) {
                                                    //     setTemplateData({ ...templateData, ["templateAttachment"]: templateDataOld.templateAttachment });
                                                    // } else {
                                                    // }
                                                }}
                                                ref={attachment} type="file" />
                                        </div>
                                        <label title={selectedFileName} className="custom-truncate-filename font-12 w-100 regular-text">{selectedFileName}</label>
                                        <label className="text-danger">
                                            {uploadValidation}
                                        </label>
                                    </div>
                                </div>
                                <div className="col-md-12 d-flex justify-content-end">
                                    <button onClick={() => { navigate("/goaltemplate", { state: { ...state } }) }} className="btn  hive-btn-secondary me-2">
                                        Cancel
                                    </button>
                                    <button
                                        disabled={disabledCheck}
                                        className="btn  hive-btn-primary" onClick={() => { submitClick() }}>
                                        {templateId ? 'Save' : 'Create Goal Template'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> : <Loader isLoading={isLoading} />}
        </>
    );
}
